require('../../modules/es6.array.find');
module.exports = require('../../modules/_core').Array.find;


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/core-js/fn/array/find.js
// module id = 204
// module chunks = 1